

const HelperPrice = {

    format: ( price ) => {
        if ( !price ) {
            return '0';
        }

        return '€ ' + price.toFixed(2).replace('.', ',');
    }
}

export default HelperPrice;